// extracted by mini-css-extract-plugin
export default {"correctAnswer":"endgame-window_correctAnswer__7Ps0B","endGameWindow":"endgame-window_endGameWindow__zAFk+"};